import React from 'react'
import { locale, addLocale } from 'primereact/api';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';

import InputWrapper from './InputWrapper';

// Utilities

import { setNestedFieldName, setNestedFieldError } from '../../../utilities/helper-functions';

import './Styles.scss';

locale('es');

addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['Domingo', 'Llunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Limpiar',
});

export default function CalendarInput(props) {
    const {
        formik,
        fieldName,
        minDate, 
        maxDate,
        isRequired,
        placeholder,
        disabled,
    } = props;

    const value = fieldName.includes('.') ? setNestedFieldName(fieldName, formik.values) : formik.values[fieldName];
    const error = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.errors) : formik.errors[fieldName];
    const touched = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.touched) : formik.touched[fieldName];

    return (
        <InputWrapper {...props}>

            <Calendar
                id={fieldName}
                name={fieldName}
                dateFormat="dd/mm/yy"
                locale="es"
                value={value ? moment(value).toDate() : ''}
                onChange={(e) => e.value ? formik.setFieldValue(fieldName, moment(e.value).format()?.replace('-04:00',"-04:30")) : formik.setFieldValue(fieldName, '')}
                onBlur={formik.handleBlur(fieldName)}
                placeholder={placeholder}
                className={`input-field ${error && touched ? 'p-invalid' : ''}`}
                minDate={minDate}
                maxDate={maxDate}
                required={isRequired}
                disabled={disabled}
            />

        </InputWrapper>
    )
}

